var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#009e49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.889 440.889h398.222C486.528 440.889 512 415.417 512 384V256L25.74 431.594a56.602 56.602 0 0 0 31.149 9.295zM455.111 71.111H56.889a56.603 56.603 0 0 0-31.147 9.294l486.256 175.592-.003.001.005.002V128c0-31.417-25.472-56.889-56.889-56.889z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.742 80.405a57.132 57.132 0 0 0-6.272 4.766l25.584 18.477L462.22 255.996l-.003.001.005.002L45.058 408.347l-.002.001-25.587 18.48a56.893 56.893 0 0 0 6.267 4.763l486.259-175.593.003-.001L25.742 80.405z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M45.058 408.347L462.221 256l-.005-.002L45.058 103.653 256 256z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.058 408.347L256 256 45.058 103.653l-.002-.001-25.587-18.48A57.158 57.158 0 0 0 8.2 98.566l219.356 157.429-.004.003.004.003-90.827 65.185-128.528 92.25a57.143 57.143 0 0 0 11.268 13.392l25.587-18.48.002-.001z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.552 255.997l.004-.003L8.2 98.565C2.997 107.153 0 117.227 0 128v256c0 10.774 2.997 20.848 8.201 29.436l128.528-92.251 90.823-65.188z",
    fill: "#ce1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/gy.def31e4c57e0cbf6aee14f90804e5e18.svg";
export { ForwardRef as ReactComponent };